function Disclaimer() {
  return (
    <>
      <section class="py-8 bg-auto bg-image">
        <div class="container my-lg-8">
          <div class="row justify-content-center py-6">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-4 text-white fw-bold">
                  <span>Disclaimer</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item lead">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active lead text-white"
                    aria-current="page"
                  >
                    Disclaimer
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-8">
        <div className="container">
          <h1 class="fw-bold lh-1">Disclaimer</h1>
          <p className="lead lh-sm text-danger mb-3">
            Microfinancebazar operates as a subsidiary brand under the umbrella
            of XXXXXX. This platform provides a comprehensive overview of loan
            offerings and investment opportunities from various sources,
            including Banks, Non-Banking Financial Companies (NBFCs), NBFC-Micro
            Finance Institutions (MFIs), Non-Profit Companies registered u/s
            Section 8 MFIs as a Business Correspondent (BC) partner.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            As a leading Indian FINTECH entity, Microfinancebazar integrates
            Microfinance Institutions and their branches, renowned for
            delivering outstanding deals across a diverse array of financial
            products such as loans, investments, and savings accounts. It is
            recognized as a hub for borrowers seeking significant discounts,
            thus becoming synonymous with substantial savings.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            However, it is important to note that the platform does not offer
            in-depth explanations tailored to individual situations. Responses
            to specific inquiries may vary based on different interpretations,
            administrative decisions, and legal proceedings
          </p>
        </div>
      </section>
    </>
  );
}

export default Disclaimer;
